module.exports = __webpack_public_path__ + "8a649e1686a7836e120613d3a7948f66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/glyphs/g.png
// module id = 210
// module chunks = 0